const VixUtily = class {
    constructor() {
        this.scrollY = window.scrollY || document.documentElement.scrollTop;
        this.floatingEl = document.querySelector('.wrap_floating');
        this.btnTop = document.querySelector('.btn_top');
        this.companyManager = document.querySelector('#sri_header .company_manager');
        this.layerList = document.querySelectorAll('#sri_header .gnb_menu_layer');
        this.MUSTGNBFLAG = false;
        this.init();
    }
    init() {
        this.gnbUtility();
        this.applicantLnbEvent();
        this.scrollDetecting();
        this.bindEvent();
    }
    bindEvent() {
        if(this.btnTop) this.btnTop.addEventListener('click', _ =>  window.scrollTo(0, 0));
        document.addEventListener('click', e => this.LnbMenuCheck(e));
        document.addEventListener('scroll', _ => this.scrollDetecting());
        document.addEventListener('DOMContentLoaded', _ =>  this.sectionAxis = window.pageYOffset + document.getElementById('content').getBoundingClientRect().top);
    }

    LnbMenuCheck(e) {
        let target = e.target;
        if (!target.closest('#sri_header')) {
            if (!!this.layerList) {
                this.removeClass(this.layerList,'show');
            }

            if (!!this.companyManager) {
                this.companyManager.classList.remove('active');
            }
        }
    }
    removeClass(elm, className) {
        if(!elm) return false;
        elm.forEach(el => el.classList.remove(className));
    }
    gnbUtility() {
        const btnMenu = document.querySelectorAll('button.btn_menu');

        if (!this.layerList) return false;

        btnMenu.forEach(item => {
            item.addEventListener('click', e => {
                const btnParent = e.currentTarget.parentElement;

                let gnbMenuLayer;
                if (btnParent.classList.contains('gnb_menu_layer')) {
                    gnbMenuLayer = btnParent;
                } else {
                    gnbMenuLayer = btnParent.querySelector('.gnb_menu_layer');
                }

                // 닫기 클릭시
                if (e.currentTarget.classList.contains('btn_close')) {
                    this.removeClass(this.layerList, 'show');
                    this.MUSTGNBFLAG = false;
                    return false;
                }

                if (!gnbMenuLayer) {
                    this.MUSTGNBFLAG = false;
                    return false;
                }

                const isGnbMenuLayerShow = gnbMenuLayer.classList.contains('show');

                if (isGnbMenuLayerShow) {
                    this.removeClass(this.layerList, 'show');
                    this.MUSTGNBFLAG = false;
                } else {
                    this.removeClass(this.layerList, 'show');
                    gnbMenuLayer.classList.add('show');
                    this.MUSTGNBFLAG = true;
                }

                // 프로필 메뉴 클릭시
                if (!this.companyManager) {
                    return false;
                }

                if (btnParent.classList.contains('login_menu_item') && !isGnbMenuLayerShow) {
                    this.companyManager.classList.add('active');
                } else {
                    this.companyManager.classList.remove('active');
                }
            });
        });
    }
    applicantLnbEvent() {
        const lnbApplicant = document.querySelector('.wrap_lnb_applicant');
        if(!lnbApplicant) return false;

        const btnRecruit = document.getElementById('btn_recruit');
        if(!btnRecruit) return false;

        const layerRecruit = btnRecruit.parentNode;
        btnRecruit.addEventListener('click', _ => layerRecruit.classList.contains('on') ? layerRecruit.classList.remove('on') : layerRecruit.classList.add('on'));
    }
    scrollDetecting() {
        this.scrollY = window.scrollY || document.documentElement.scrollTop;
        let axisDefine = window.pageYOffset + document.getElementById('content').getBoundingClientRect().top;
        if (this.MUSTGNBFLAG === true && this.scrollY > axisDefine) {
            if (!!this.layerList) {
                this.removeClass(this.layerList,'show');
            }

            if (!!this.companyManager) {
                this.companyManager.classList.remove('active');
            }
        }
        if(this.btnTop) this.scrollY >= axisDefine ? this.floatingEl.classList.add('show') : this.floatingEl.classList.remove('show');
    }
};
export default VixUtily;
